import { render } from "./sdltgd.vue?vue&type=template&id=6f6dadec&scoped=true&ts=true"
import script from "./sdltgd.vue?vue&type=script&lang=ts"
export * from "./sdltgd.vue?vue&type=script&lang=ts"

import "./sdltgd.vue?vue&type=style&index=0&id=6f6dadec&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6dadec"]])

export default __exports__